import {
  SNACKBAR,
  SNACKBAR_GLOBAL_NOTIFICATIONS,
  SNACKBAR_CLOSE,
  SNACKBAR_RESOLVE_GLOBAL_NOTIFICATION,
  SNACKBAR_CLOSE_ALL,
} from "@/store/actions/snackbar";

export const getDefaultState = () => ({
  snackbar: {
    active: false,
    text: null,
    timeout: 4000,
    color: "blue",
    globalNotifications: {},
  },
  activeSnackbars: [],
});
const state = getDefaultState();

const getters = {
  getSnackbarStatus: (state) => state.snackbar,
  getActiveSnackbars: (state) => state.activeSnackbars,
};

const actions = {
  //REFACTOR: Do it with a async generators...
  [SNACKBAR_GLOBAL_NOTIFICATIONS]: ({ commit, dispatch }, payload) => {
    const checkGlobalNotification = (arr, ind) => {
      return new Promise((resolve, reject) => {
        if (ind >= arr.length) {
          reject();
          commit(SNACKBAR_CLOSE);
          return;
        }
        const notification = localStorage.getItem(
          "global-notification-marked-as-read-" + arr[ind].id
        );
        if (notification === null) {
          resolve(arr[ind]);
        } else {
          checkGlobalNotification(arr, ind + 1).then(
            (x) => {
              resolve(x);
            },
            () => {
              reject();
            }
          );
        }
      });
    };
    checkGlobalNotification(payload, 0).then(
      (notif) => {
        if (notif === null || typeof notif === "undefined") {
          return;
        }
        commit(SNACKBAR, {
          active: true,
          text: notif.message,
          timeout: 0,
          color: "primary",
          globalNotifications: { payload, id: notif.id },
        });
      },
      () => {
        // Nothing to do, notif not available
      }
    );
  },
  [SNACKBAR_RESOLVE_GLOBAL_NOTIFICATION]: ({ commit, dispatch }, id) => {
    localStorage.setItem(
      "global-notification-marked-as-read-" + id,
      new Date()
    );
  },
};

const mutations = {
  [SNACKBAR]: (state, value) => {
    state.snackbar = { ...value, id: Symbol() };
    state.activeSnackbars.push(value);
  },
  [SNACKBAR_CLOSE]: (state, id) => {
    Object.assign(state.snackbar, getDefaultState().snackbar);
    const index = state.activeSnackbars.findIndex((item) => {
      item.id === id;
    });
    state.activeSnackbars.splice(index, 1);
  },
  [SNACKBAR_CLOSE_ALL]: (state) => {
    Object.assign(state, getDefaultState());
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
